export default class VideoComponent {
  constructor() {
    const swiper = new Swiper('.videos-post', {
      autoHeight: true,
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.slider-button-next',
        prevEl: '.slider-button-prev',
      },
      pagination: {
        el: '.slider-pagination',
        clickable: true,
      },
    })
  }
}
new VideoComponent();
